import styled from "styled-components";
import {HeaderNavbarContainerDefaultBox} from "./header-navbar-container.default.box";

export const HeaderNavbarContainerCasino888Box = styled(HeaderNavbarContainerDefaultBox)`
  border-color: ${props => props.theme.colors.backgroundDark};
  flex-wrap: wrap;
`;
